import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { getAllSsqVersionAssignmentsKey } from "src/api/client-api/questionnaire/useGetAllSsqVersionAssignments";

type CreateSsqVersionAssignmentPayload = {
    ssqId: number;
    ssqVersionId: number;
    campaign: IRI;
};

export const useCreateSsqVersionAssignment = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload: CreateSsqVersionAssignmentPayload) => {
            const response = await loggedInApiCall.post("/api/ssq-version-assignments", payload);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(getAllSsqVersionAssignmentsKey);
        },
    });
};
